import { Settings } from '@unistocks/features/settings/settings';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function SettingsScreen() {
  return (
    <>
      <Head>
        <title>{t('::Menu:Settings')}</title>
      </Head>
      <Settings />
    </>
  );
}
